<template>
  <div class="t-input">
    <label v-html="label"/>
    <span v-if="area">
      <textarea
        :class="`${_class} area`"
        :placeholder="placeholder"
        v-model="_value"/>
        <div class="text-error">
          <span v-if="error" v-html="error"/>
        </div>
    </span>
    <span v-else>
      <input
        :type="type"
        :class="_class"
        :placeholder="placeholder"
        v-model="_value"/>
        <div class="text-error">
          <span v-if="error" v-html="error"/>
        </div>
    </span>
  </div>
</template>

<script>
export default {
  name: 't-input',
  props: ['label', 'placeholder', 'area', 'type', 'error', 'value', 'inputClasses'],
  computed: {
    _class () {
      return `input ${!this.inputClasses ? '' : this.inputClasses} ${this.error ? 'error' : ''}`
    },
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.t-input {
  label {
    color: var(--on-background);
    display: block;
    font-weight: $semi-bold;
    margin-bottom: 10px;
  }
  .text-error {
    color: $error-color;
    font-size: 14px;
    margin-left: 10px;
    height: 20px;
  }
  .input {
    background-color: var(--surface);
    color: var(--on-surface);
    width: 100%;
    height: 40px;
    border: none;
    border-radius: 10px;
    font-size: 18px;
    padding: 0 15px;
    &.error {
      box-shadow: inset 0px 0px 3px 1px $error-color;
      color: $error-color;
    }
    box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.1);
    &.area {
      padding-top: 15px;
      min-height: 193px;
      resize: none;
    }

    @include for-size(tablet-portrait-up) {
      height: 60px;
    }
  }
}
</style>
